import IconifyIcon from '../IconifyIcon';
import { useNavigate } from 'react-router-dom';

const ThemeCustomizerToggle = () => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/admin/settings');
  };

  return (
    <div className="topbar-item d-none d-md-flex">
      <button
        onClick={handleClick}
        type="button"
        className="topbar-button"
        id="theme-settings-btn"
        title="Settings"
      >
        <IconifyIcon icon="solar:settings-bold-duotone" style={{ fontSize: '22px' }} />
      </button>
    </div>
  );
};

export default ThemeCustomizerToggle;
